module.exports = __webpack_public_path__ + "media/images/gateway/2-7f93505057c3a573990d1c339f826207.png";